<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system")
            i.fa.fa-desktop
            span.ml-1 {{ $t("ui.system") }}
        b-breadcrumb-item
          router-link(to="/system/role")
            i.fa.fa-id-card
            span.ml-1 {{ $tc("ui.roles", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(required autofocus type="text" v-model="roleSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
            div.row
              div.col-md-12
                b-button(v-b-modal.addRole type="button" variant="primary" size="sm")
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_role") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.text-center.sticky-position(width=120)
                      span {{ $t("ui.action") }}
                    th.sticky-position
                      span {{ $t("ui.name") }}
                    th.text-right.sticky-position(width=200)
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredRoleList")
                    td
                      span {{ item.role_id }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td
                      span {{ item.role_name }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addrole(@clicked="addRole" @failed="handleFailed")
      editrole(
        ref="editrole"
        :roleId="editSelectedId"
        :roleName="editSelectedName"
        @clicked="updateRoleName"
        @failed="handleFailed")
      deleterole(
        ref="deleterole"
        :roleId="deleteSelectedId"
        :roleName="deleteSelectedName"
        @clicked="deleteRole"
        @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addrole from "@/components/role/addRole.vue";
import editrole from "@/components/role/editRole.vue";
import deleterole from "@/components/role/deleteRole.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    addrole,
    editrole,
    deleterole,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      roleList: [],
      roleSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedId: "",
      editSelectedName: "",
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    filteredRoleList() {
      return this.roleList.filter(roleInfo => {
        if (this.filterBy == "name") {
          return roleInfo.role_name.toLowerCase().indexOf(this.roleSearch.toLowerCase()) > -1;
        } else {
          return roleInfo.role_id.indexOf(this.roleSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    let url = config.roleListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.role
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.roleList = response.data.tbl_role_list;
            } else {
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    onEdit(e) {
      this.editSelectedId = e.role_id;
      this.editSelectedName = e.role_name;
      this.$refs.editrole.$refs.editRole.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.role_id;
      this.deleteSelectedName = e.role_name;
      this.$refs.deleterole.$refs.deleteRole.show();
    },
    addRole: function(roleId, roleName) {
      let newRole = {
        role_id: roleId,
        role_name: roleName.toUpperCase(),
        created_on: new Date()
      };

      this.roleSearch = "";
      this.roleList.unshift(newRole);
      this.$helpers.showDialog(this.$t("ui.combine.add_role"), this.$t("message.success"), "success");
    },
    updateRoleName: function(roleId, roleName) {
      this.roleList.filter(function(roleInfo) {
        if (roleInfo.role_id == roleId) {
          roleInfo.role_name = roleName.toUpperCase();
        }
      });

      this.$helpers.showDialog(this.$t("ui.combine.edit_role"), this.$t("message.success"), "success");
    },
    deleteRole: function(roleId) {
      let i = this.roleList.map(roleInfo => roleInfo.role_id).indexOf(roleId);
      this.roleList.splice(i, 1);

      this.$helpers.showDialog(this.$t("ui.combine.delete_role"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      // this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>

